export default __webpack_public_path__ + "static/front-cover-rainforest-684be5cf5c33f7197f02fc5f3c654b56.jpg";